import Page from "../../components/PrivacyPolicy/Page";
import { privacyPolicyData } from "./data";

const PrivacyPolicy: React.FC = () => {
  return (
    <Page pageTitle="Fipay.io Privacy Policy" sections={privacyPolicyData} />
  );
};

export default PrivacyPolicy;
